// https://github.com/biati-digital/glightbox
import 'glightbox/dist/css/glightbox.css';
import GLightbox from 'glightbox';


//standard lightbox
const lightbox = GLightbox();
lightbox.on('close', () => {
    // Resume background vimeo cover after closing modal video
    $('.iframe--cover iframe').each(function() {
        if (this && this.contentWindow) {
            this.contentWindow.postMessage(JSON.stringify({ method: 'play' }), '*');
        }
    });
});

const fellowLightbox = GLightbox({
    selector: '.fellow-lightbox, .fachperson-lightbox',
    touchNavigation: false,
    touchFollowAxis: false,
    keyboardNavigation: false,
    loop: false,
    draggable: false,
    zoomable: false,
    height: 'auto',
    width: '1248px',
    skin: 'fellowbox'
});
fellowLightbox.on('open', () => {
    $('.button--close--fellowbox').click(function() {
        fellowLightbox.close();
    });
});

//search box header
$(document).ready(function() {

    const searchbox = GLightbox({
        touchNavigation: false,
        touchFollowAxis: false,
        keyboardNavigation: false,
        selector: ".searchboxlink",
        zoomable: false,
        draggable: false,
        height: 'auto'
    });
    searchbox.on('open', () => {
        $('input[type="search"]').select();
        $('.button--close').click(function() {
            searchbox.close();
        })
    });

});
